import {cerrarSesion} from '../utilities/Seguridad'
import axios from 'axios'

const qs = require('qs');

export async function getListaPerfil(token,idColegio) {

  let config = {
    method: 'get',
    url: `${process.env.REACT_APP_URL}/rol/listar`,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json', 
      'idcolegio': idColegio, 
    }
  };

  const response = await axios(config)
    .then((response) => {
      if(response.data.error===1) cerrarSesion(response.data);
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      return null;
    });
  return response;
}

export async function getListaAccionesPerfil(idrol,idcolegio,token) {

  let config = {
    method: 'get',
    url: `${process.env.REACT_APP_URL}/rol/${idrol}/acciones`,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json', 
      'idcolegio': idcolegio, 
    }
  };

  const response = await axios(config)
    .then((response) => {
      if(response.data.error===1) cerrarSesion(response.data);
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      return null;
    });
  return response;
}

export async function asignarAccionesPerfil(idrol,acciones,token) {

  let dataAcciones = qs.stringify({
    'acciones': acciones
   });

  let config = {
    method: 'put',
    url: `${process.env.REACT_APP_URL}/rol/${idrol}/asignar-acciones`,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/x-www-form-urlencoded', 
    },
    data: dataAcciones
  };

  const response = await axios(config)
    .then((response) => {
      if(response.data.error===1) cerrarSesion(response.data);
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      return null;
    });
  return response;
}

export async function crearPerfil(perfil,idcolegio,token) {
  let data = qs.stringify({
    'rol': perfil.rol,
   'descripcion': perfil.descripcion,
   'estado': perfil.estado?1:2 
   });

  let config = {
    method: 'post',
    url: `${process.env.REACT_APP_URL}/rol/crear`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded', 
      'idcolegio': idcolegio, 
      'Authorization': `Bearer ${token}`
    },
    data: data
  };

  const response = await axios(config)
    .then((response) => {
      if(response.data.error===1) cerrarSesion(response.data);
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      return null;
    });
  return response;
}

export async function editarPerfil(perfil,idcolegio,token) {

  let data = qs.stringify({
    'rol': perfil.rol,
   'descripcion': perfil.descripcion,
   'estado': perfil.estado?1:2
   });

  let config = {
    method: 'put',
    url: `${process.env.REACT_APP_URL}/rol/editar/${perfil.id}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded', 
      'idcolegio': idcolegio, 
      'Authorization': `Bearer ${token}`
      //'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiaWF0IjoxNjU3OTg1MzIwLCJleHAiOjE2NTgwNzE3MjB9.coQX5wqTYueKGbtLQyy4sDjjTckYYCacQY2n9f2emPY`
    },
    data: data
  };

  const response = await axios(config)
    .then((response) => {
      if(response.data.error===1) cerrarSesion(response.data);
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      return null;
    });
  return response;
}

export async function eliminarPerfil(id,idcolegio,token) {

  let config = {
    method: 'delete',
    url: `${process.env.REACT_APP_URL}/rol/eliminar/${id}`,
    headers: {
      'Content-Type': 'application/json',
      'idcolegio': idcolegio, 
      'Authorization': `Bearer ${token}`
    }
  };

  const response = await axios(config)
    .then((response) => {
      if(response.data.error===1) cerrarSesion(response.data);
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      return null;
    });
  return response;
}